import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycabserviceinpune() {



const cardData = {
  keyword: " Monthly Cab Service in Pune ",

"headingDescription": "SRS Cab Service offers Monthly Cab Service in Pune, providing reliable, safe, and convenient transportation solutions for professionals, students, and families. Whether it’s daily office commutes, college travel, airport transfers, or regular city rides, our well-maintained fleet and professional drivers ensure a hassle-free and punctual journey every day. With flexible plans, transparent pricing, and 24/7 customer support, SRS Cab Service makes monthly commuting in Pune simple, affordable, and stress-free.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub where professionals rely on SRS Cab Service for monthly commuting plans, ensuring timely and consistent travel to offices."
  },
  {
    "title": "Hinjewadi Phase 1 & 2",
    "description": "An important corporate area. Monthly cab service users depend on SRS Cab Service for daily office commutes and smooth travel routines."
  },
  {
    "title": "Magarpatta City",
    "description": "A prominent corporate and IT campus. Travelers using SRS Cab Service for monthly plans enjoy reliable rides to and from Magarpatta City."
  },
  {
    "title": "EON IT Park",
    "description": "SRS Cab Service provides dependable monthly cab solutions for employees commuting daily to EON IT Park."
  },
  {
    "title": "Kalyani Nagar",
    "description": "A residential and commercial hub. Monthly cab service clients rely on SRS Cab Service for regular office or personal travel from this area."
  },
  {
    "title": "Viman Nagar",
    "description": "A key business and IT locality. Users of monthly cab plans enjoy consistent and hassle-free commuting with SRS Cab Service."
  },
  {
    "title": "Baner",
    "description": "An important commercial and IT zone. Monthly cab service users rely on SRS Cab Service for punctual daily rides to Baner offices."
  },
  {
    "title": "Pimpri Chinchwad Industrial Area",
    "description": "Industrial and corporate offices benefit from SRS Cab Service monthly plans for staff commuting and operational travel."
  },
  {
    "title": "Hadapsar",
    "description": "A fast-growing corporate and industrial hub. Monthly cab service from SRS Cab Service ensures reliable and safe daily commuting."
  },
  {
    "title": "Wakad",
    "description": "A residential and IT hub. Professionals and students using SRS Cab Service monthly plans enjoy consistent, comfortable rides every day."
  }
],



services: [
{
name: "Monthly Cab Service in Pune",
description: "Monthly cab service in Pune offers reliable transportation for daily travel and office commute. Customers can book long-term cab plans easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible pricing options are available. Travel easily with monthly cab services."
},
{
name: "Pune Monthly Cab Service",
description: "Pune monthly cab service provides convenient travel solutions for regular commuters. Customers can book cabs for daily office and personal use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with monthly cab services."
},
{
name: "Monthly Taxi Service Pune",
description: "Monthly taxi service Pune offers dependable travel for daily and long-term use. Customers can book taxis for fixed monthly plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Monthly Cab Booking Pune",
description: "Monthly cab booking Pune provides easy reservation options for long-term travel. Customers can book cabs for regular commute needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Book your cab easily for monthly travel."
},
{
name: "Monthly Taxi Booking Pune",
description: "Monthly taxi booking Pune offers convenient booking services for daily travel needs. Customers can reserve taxis for long-term use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab on Monthly Basis Pune",
description: "Cab on monthly basis Pune provides flexible travel solutions for regular users. Customers can book cabs for office and personal travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible pricing plans are available. Travel easily with monthly cab services."
},
{
name: "Taxi on Monthly Basis Pune",
description: "Taxi on monthly basis Pune offers reliable transport for daily and long-term travel. Customers can book taxis for fixed monthly usage. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Monthly Cab Hire Pune",
description: "Monthly cab hire Pune offers long-term rental options for individuals and companies. Customers can book cabs for daily travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with cab hire services."
},
{
name: "Monthly Taxi Hire Pune",
description: "Monthly taxi hire Pune provides convenient rental services for regular travel. Customers can book taxis for office and personal use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Monthly Car Rental Pune with Driver",
description: "Monthly car rental Pune with driver offers hassle-free travel for daily commute. Customers can book cars with professional drivers. Safe and comfortable journeys are ensured. Flexible plans are available. Ideal for office and personal travel. Travel easily with car rental services."
},
{
name: "Monthly Cab Package Pune",
description: "Monthly cab package Pune provides cost-effective travel solutions for regular users. Customers can choose customized travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible pricing options are available. Travel easily with cab packages."
},
{
name: "Monthly Taxi Package Pune",
description: "Monthly taxi package Pune offers budget-friendly travel plans for daily use. Customers can select suitable packages for their needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi packages."
},
{
name: "Monthly Cab Service for Office Pune",
description: "Monthly cab service for office Pune provides reliable travel for employees and professionals. Companies can arrange daily office commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with office cab services."
},
{
name: "Monthly Cab Service for Employees Pune",
description: "Monthly cab service for employees Pune offers convenient transport for staff. Companies can book long-term cab solutions. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with employee cab services."
},
{
name: "Monthly Cab Service Near Me Pune",
description: "Monthly cab service near me Pune helps customers find nearby long-term transport options. Users can book cabs easily for daily travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with cab services."
},
{
name: "Affordable Monthly Cab Service Pune",
description: "Affordable monthly cab service Pune offers budget-friendly travel for regular users. Customers can book economical cab plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible pricing options are available. Travel easily with affordable cab services."
},
{
name: "Best Monthly Cab Service Pune",
description: "Best monthly cab service Pune provides top-rated travel solutions for daily commute. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Monthly Cab Service Pune Price",
description: "Monthly cab service Pune price offers transparent and competitive pricing for long-term travel. Customers can choose plans based on budget. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible packages are available. Travel easily with affordable pricing."
},
{
name: "Monthly Cab Contract Pune",
description: "Monthly cab contract Pune provides long-term transport agreements for companies and individuals. Businesses can manage employee travel efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible contract options are available. Travel easily with cab contracts."
},
{
name: "Long Term Cab Service Pune",
description: "Long term cab service Pune offers reliable travel solutions for extended use. Customers can book cabs for months or longer. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with long-term cab services."
},
{
name: "Innova Monthly Cab Pune",
description: "Innova monthly cab Pune offers spacious SUV travel for families and corporate users. Customers can book vehicles for long-term travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for group travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Monthly Cab Pune",
description: "Innova Crysta monthly cab Pune provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family use. Flexible plans are available. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Monthly Cab Pune",
description: "Ertiga monthly cab Pune offers comfortable 7 seater travel for regular users. Customers can book vehicles for office and personal travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible plans are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Monthly Cab Pune",
description: "Dzire monthly cab Pune provides affordable sedan travel for daily commute. Customers can book vehicles for long-term use. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Monthly Cab Pune",
description: "Sedan monthly cab Pune offers budget-friendly travel for daily office and personal use. Customers can book vehicles for long-term plans. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible options are available. Travel easily with sedan cab services."
},
{
name: "SUV Monthly Cab Pune",
description: "SUV monthly cab Pune provides spacious travel for families and corporate users. Customers can book vehicles for long-distance and daily use. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SUV cab services."
},
{
name: "Luxury Monthly Cab Pune",
description: "Luxury monthly cab Pune offers premium travel experience for corporate and VIP users. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible plans are available. Travel easily with luxury cab services."
}
],

tableData: [
["Monthly Cab Service in Pune","Pune Monthly Cab Service"],
["Monthly Taxi Service Pune","Monthly Cab Booking Pune"],
["Monthly Taxi Booking Pune","Cab on Monthly Basis Pune"],
["Taxi on Monthly Basis Pune","Monthly Cab Hire Pune"],
["Monthly Taxi Hire Pune","Monthly Car Rental Pune with Driver"],
["Monthly Cab Package Pune","Monthly Taxi Package Pune"],
["Monthly Cab Service for Office Pune","Monthly Cab Service for Employees Pune"],
["Monthly Cab Service Near Me Pune","Affordable Monthly Cab Service Pune"],
["Best Monthly Cab Service Pune","Monthly Cab Service Pune Price"],
["Monthly Cab Contract Pune","Long Term Cab Service Pune"],
["Innova Monthly Cab Pune","Innova Crysta Monthly Cab Pune"],
["Ertiga Monthly Cab Pune","Dzire Monthly Cab Pune"],
["Sedan Monthly Cab Pune","SUV Monthly Cab Pune"],
["Luxury Monthly Cab Pune","Monthly Cab Service in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Monthly Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service offers dependable monthly cab service in Pune for daily office commute, employee transport, school runs, and regular travel with fixed plans and professional drivers."
  },
  {
    WhyChooseheading: "Cost-Effective Monthly Plans",
    WhyChoosedescription: "We provide affordable monthly cab packages with transparent pricing, helping individuals and companies save on daily travel costs with fixed monthly billing."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Scheduling",
    WhyChoosedescription: "Our monthly cab service allows flexible pickup and drop timings based on your daily schedule, including office shifts, school timings, and personal travel needs."
  },
  {
    WhyChooseheading: "Dedicated Cab & Driver Option",
    WhyChoosedescription: "Get a dedicated cab and driver for your monthly travel requirements, ensuring consistency, comfort, and reliability every day."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles depending on your usage and group size."
  },
  {
    WhyChooseheading: "Safe, Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are regularly cleaned, sanitized, and maintained to ensure safe and comfortable travel for daily use."
  },
  {
    WhyChooseheading: "Ideal for Office, School & Personal Use",
    WhyChoosedescription: "Our monthly cab service is perfect for office employees, students, corporate staff, and families needing daily reliable transport."
  },
  {
    WhyChooseheading: "Trusted Monthly Cab Provider in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by individuals and companies in Pune for punctual service, professional drivers, and consistent travel experience."
  }
]
}

const faqData = [
  { 
    question: "Do you provide monthly cab service in Pune?", 
    answer: "Yes, SRS Cab Service offers reliable monthly cab service in Pune for daily office commute, employee transport, school trips, and regular personal travel with flexible plans." 
  },
  { 
    question: "What is included in monthly cab service?", 
    answer: "Monthly cab service includes fixed pickup and drop schedules, dedicated or shared vehicles, professional drivers, and cost-effective pricing plans based on your travel needs." 
  },
  { 
    question: "Can I customize monthly cab plans?", 
    answer: "Yes, we provide fully customizable monthly cab plans including route selection, timing flexibility, vehicle type, and service duration." 
  },
  { 
    question: "Which vehicles are available for monthly service?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and luxury vehicles depending on your daily travel requirements." 
  },
  { 
    question: "Is monthly cab service available for office employees?", 
    answer: "Yes, our monthly cab service is widely used for employee transportation and corporate travel across Pune." 
  },
  { 
    question: "Do you provide dedicated cab and driver?", 
    answer: "Yes, we offer dedicated cab and driver options for customers who need consistent daily travel service." 
  },
  { 
    question: "Is service available 7 days a week?", 
    answer: "Yes, our monthly cab service is available 7 days a week with flexible scheduling based on your requirements." 
  },
  { 
    question: "Are monthly cab services affordable?", 
    answer: "Yes, monthly cab services are more cost-effective compared to daily bookings, offering better value for regular travel." 
  },
  { 
    question: "Are vehicles safe and clean?", 
    answer: "Yes, all vehicles are regularly cleaned, sanitized, and maintained for safe and comfortable daily use." 
  },
  { 
    question: "How can I book monthly cab service in Pune?", 
    answer: "You can book monthly cab service by contacting us directly. We provide quick setup and customized plans based on your travel needs." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "I have been using monthly cab service for office commute in Pune and the experience has been excellent. The driver is always on time, the car is clean, and service is very reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best monthly cab service in Pune. I booked for daily office travel and it saved a lot of time and cost. Driver is professional and overall experience is very smooth.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Monthly Cab Service Pune",
  "description": "Reliable monthly cab service in Pune with SRS Cab. Book cabs on a monthly basis for daily commute, office travel, and personal use. 24/7 service with Innova, Ertiga, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/monthly-cab-service-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};





  return (
    <div>
      <Helmet>
  <title>Monthly Cab Service in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable monthly cab service in Pune with SRS Cab. Cabs available for daily commute, office travel, and personal use. Innova, Ertiga, sedan, SUV, and tempo traveller options available 24/7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycabserviceinpune;